import { combineReducers } from "@reduxjs/toolkit";
import user from "../Slice/User/user";
import notification from "../Slice/notificationSlice";

export default function createReducer() {
  const rootReducer = combineReducers({
    user,
    notification
  });

  return rootReducer;
}
